import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { MemberUser } from '@youhelp-ru/core';

const name = 'dialogUser';
export type SliceShape = { [name]: MemberUser | null };

export const slice = createSlice({
  name,
  initialState: null as MemberUser | null,
  reducers: {
    setDialogUser: (_, action: PayloadAction<MemberUser>) => {
      return action.payload;
    },
    resetDialogUser: () => {
      return null;
    },
  },
});

export const selectDialogUser = (state: SliceShape) => state.dialogUser;

export const reducerConfig = {
  [name]: slice.reducer,
};
